import React from 'react';
import { getAnalytics } from '../analytics';
import propTypes from 'prop-types';
import ApiClient from 'api/ApiClient';
import { signout as signoutPath } from 'apps/account/paths';
import { localisedPath } from 'common/url_locale_helper';

export default class LogOutLink extends React.Component {
  static defaultProps = {
    element: 'a',
  };

  static propTypes = {
    className: propTypes.string,
    onClick: propTypes.func,
  };

  handleClick = () => {
    this.props.onClick && this.props.onClick();
    ApiClient.makeRequest(signoutPath(), { method: 'delete' }).then(() => {
      getAnalytics().track('User Logged Out');
      setTimeout(() => {
        window.location.assign(localisedPath('/'));
      }, 200);
    });
  };

  render() {
    const { children, className } = this.props;
    const Element = this.props.element;
    return (
      <Element className={className} onClick={this.handleClick}>
        {children}
      </Element>
    );
  }
}
